import React from 'react';

import { Upsell } from 'pages/cart/upsell';

import { UpsellCarouselWrapper } from './product-upsell-styled';

export const ProductUpsell: React.FC = () => (
  <UpsellCarouselWrapper>
    <Upsell />
  </UpsellCarouselWrapper>
);
